import React from 'react';
interface LogoProps {
  size?: 'small' | 'large';
  className?: string;
}
export function Logo({
  size = 'large',
  className = ''
}: LogoProps) {
  const dimension = size === 'large' ? 120 : 60;
  const fontSize = size === 'large' ? 'text-4xl' : 'text-xl';
  const textSize = size === 'large' ? 10 : 6;
  return <div className={`inline-flex items-center justify-center ${className}`} data-id="element-99">
      <svg width={dimension} height={dimension} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-100">
        <circle cx="60" cy="60" r="58" fill="#F9C6D0" stroke="#C9A84C" strokeWidth="2" data-id="element-101" />
        <text x="60" y="70" textAnchor="middle" fill="#C9A84C" fontSize="42" fontWeight="bold" fontFamily="Playfair Display, serif" data-id="element-102">
          VR
        </text>
        <path id="circlePath" d="M 60, 60 m -50, 0 a 50,50 0 1,1 100,0 a 50,50 0 1,1 -100,0" fill="none" data-id="element-103" />
        <text fill="#C9A84C" fontSize={textSize} fontFamily="Poppins, sans-serif" letterSpacing="2" data-id="element-104">
          <textPath href="#circlePath" startOffset="25%" data-id="element-105">
            BEAUTY STUDIO
          </textPath>
        </text>
      </svg>
    </div>;
}